<template>
  <ProductCatalogListingFigma :kind="kind" />
</template>

<script setup>
/* eslint-disable no-undef */
import ProductCatalogListingFigma from './ProductCatalogListingFigma.vue'

defineProps({
  kind: { type: String, default: 'accommodation' },
})
</script>
